import React from 'react';
import Icon from '../../../components/AppIcon';

const ConversationStats = ({ conversations }) => {
  const totalConversations = conversations?.length;
  const unreadCount = conversations?.filter(c => c?.unreadCount > 0)?.length;
  const responseRequired = conversations?.filter(c => c?.responseRequired)?.length;
  const smsConversations = conversations?.filter(c => c?.channel === 'sms')?.length;

  const stats = [
    {
      label: 'Total Conversations',
      value: totalConversations,
      icon: 'MessageSquare',
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    {
      label: 'Unread Messages',
      value: unreadCount,
      icon: 'AlertCircle',
      color: 'text-warning',
      bgColor: 'bg-warning/10'
    },
    {
      label: 'Response Required',
      value: responseRequired,
      icon: 'Clock',
      color: 'text-error',
      bgColor: 'bg-error/10'
    },
    {
      label: 'SMS Conversations',
      value: smsConversations,
      icon: 'MessageSquare',
      color: 'text-accent',
      bgColor: 'bg-accent/10'
    }
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 p-4 bg-card border-b border-border">
      {stats?.map((stat, index) => (
        <div key={index} className="flex items-center space-x-3">
          <div className={`w-10 h-10 rounded-lg ${stat?.bgColor} flex items-center justify-center`}>
            <Icon name={stat?.icon} size={20} className={stat?.color} />
          </div>
          <div>
            <p className="text-2xl font-bold text-foreground">{stat?.value}</p>
            <p className="text-xs text-muted-foreground">{stat?.label}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ConversationStats;